import { type EdgeDirection, safeAbsurd } from '@ipfabric/utils';
import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import type { AppTranslations } from 'translations/translations';
import {
  type DeviceViewEntity,
  isPacketDetailsEntity,
  isPathlookupDebugEntity,
} from '../deviceViewTypes';

export const getEdgeArrow = (edgeDirection: EdgeDirection): string => {
  switch (edgeDirection) {
    case 'directed':
      return 'fa-long-arrow-right';
    case 'bidirected':
      return 'fa-arrows-h';
    case 'undirected':
      throw new Error('Undirected edge does not have font awesome icon');
    default:
      return safeAbsurd(edgeDirection, 'Missing edge type', '');
  }
};

const getEdgeColorsStyle = (color: number): CSSProperties => {
  return {
    background: `#${color.toString(16)}`,
  };
};

export const getTitle = (
  msg: AppTranslations,
  deviceViewEntity: DeviceViewEntity,
): ReactNode | string => {
  if (deviceViewEntity.deviceViewElement === 'edge') {
    if (!deviceViewEntity.labels) {
      return '';
    }
    return (
      <span className='inline-flex items-center'>
        {deviceViewEntity.color !== undefined && (
          <span
            className='device-view__edge-title-color mr-lgu-2 inline-block align-middle'
            style={getEdgeColorsStyle(deviceViewEntity.color)}
          />
        )}
        <span className='mr-lgu-2 inline-block'>
          {deviceViewEntity.labels[1]}
        </span>
        <span className='mr-lgu-2 inline-block'>
          {deviceViewEntity.sourceLabel}
        </span>
        {deviceViewEntity.labels[0] && (
          <span className='mr-lgu-2 inline-block'>
            ({deviceViewEntity.labels[0]})
          </span>
        )}
        {deviceViewEntity.edgeDirection === 'undirected' ? (
          <span>—</span>
        ) : (
          <i
            className={classNames(
              'fa',
              getEdgeArrow(deviceViewEntity.edgeDirection),
              'mr-lgu-2 inline-block',
            )}
          />
        )}
        <span className='mr-lgu-2 inline-block'>
          {deviceViewEntity.targetLabel}
        </span>
        {deviceViewEntity.labels[2] && (
          <span className='mr-lgu-2 inline-block'>
            ({deviceViewEntity.labels[2]})
          </span>
        )}
      </span>
    );
  }

  if (isPacketDetailsEntity(deviceViewEntity)) {
    return (
      <span className='inline-block'>{msg.deviceView.pathLookup.title}</span>
    );
  }
  if (isPathlookupDebugEntity(deviceViewEntity)) {
    return <span className='inline-block'>Debug</span>;
  }

  if (!deviceViewEntity.title) {
    return '';
  }
  return <span className='inline-block'>{deviceViewEntity.title}</span>;
};
